export function getTagCategory(schema) {
  switch (schema) {
    case 'cities':
    case 'provinces':
      return 'locations';
    case 'universities':
      return 'schools';
    default:
      return schema;
  }
}



// WEBPACK FOOTER //
// ./src/services/tagDisplayCategoriesService.js